export default __webpack_public_path__ + "static/media/activities-logo-bold.f0d2f0a1.svg";